import PropTypes from 'prop-types';
import React from 'react';
import { TextField } from '../../../../catalyst/core';
import { Field } from 'formik';
import { Grid } from '@material-ui/core';
import FormikTextField from '../../../../catalyst/core/form/TextField/variants/FormikTextField';
import FormikSelect from '../../../../catalyst/core/form/Select/variants/FormikSelect';

const FormNameField = ({ touched, errors, qlikAppsList }) => {
    const toKebabCase = (str) =>
        str &&
        str
            .match(
                /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
            )
            .map((x) => x.toLowerCase())
            .join('-');
    return (
        <>
            <Grid item>
                <Field id={'name'} label={'Name'} name={'name'}>
                    {({ field, form: { setFieldValue } }) => {
                        const onChange = (event) => {
                            const { value } = event.target;
                            const { name } = field;
                            setFieldValue(name, value);
                            setFieldValue('entity', toKebabCase(value));
                        };

                        return (
                            <TextField
                                variant={'outlined'}
                                id={'name'}
                                label={'Name'}
                                name={'name'}
                                type={'text'}
                                helperText={touched.name && errors.name}
                                required
                                error={errors.name}
                                touched={touched.name}
                                {...field}
                                onChange={onChange}
                                inputProps={{
                                    value: field.value,
                                }}
                                style={{ minWidth: '180px' }}
                            />
                        );
                    }}
                </Field>
            </Grid>
            <Grid item>
                <FormikTextField
                    id={'entity'}
                    label={'Entity'}
                    name={'entity'}
                    type={'text'}
                    helperText={
                        'This will be the entity name used in the database'
                    }
                    disabled
                />
            </Grid>
            <Grid item>
                <FormikSelect
                    id={'appId'}
                    label={'Qlik App ID'}
                    name={'qlikAppId'}
                    items={qlikAppsList}
                    style={{ minWidth: '180px' }}
                    fullWidth
                />
            </Grid>
        </>
    );
};

export default FormNameField;

FormNameField.propTypes = {
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
};
